import {Component, Inject, Optional} from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent, MatDialogRef,
    MatDialogTitle
} from "@angular/material/dialog";
import {MatRadioButton, MatRadioGroup} from "@angular/material/radio";
import {NgForOf} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ExtractUsernamePipe} from "../../../../customPipes/extract-username.pipe";


interface UserOption {
    accountId: string;
    firstName: string;
    lastName: string;
    email: string;
}

type DialogData = {
    title: string;
    options: UserOption[];
};

@Component({
  selector: 'app-user-option-select',
    imports: [
        MatDialogActions,
        MatDialogClose,
        MatDialogContent,
        MatDialogTitle,
        MatRadioButton,
        MatRadioGroup,
        NgForOf,
        FormsModule,
        ExtractUsernamePipe
    ],
  templateUrl: './user-option-select.component.html',
  styleUrl: './user-option-select.component.scss'
})
export class UserOptionSelectComponent {
    dialogTitle: string = "";
    dialogOptions: UserOption[] = [];
    selectedOption: string;

    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) private data: DialogData,
        private dialogRef: MatDialogRef<UserOptionSelectComponent>,
    ) {}

    ngOnInit() {
        if (this.data) {
            this.dialogTitle = this.data.title;
            this.dialogOptions = this.data.options;
            this.selectedOption = this.dialogOptions[0].accountId;
        }
    }

    handleResponse() {
        this.dialogRef.close(this.selectedOption);
    }
}
